module.exports = __webpack_public_path__ + "static/img/customer1.b1401158.png";